import {
  Pagination,
  PaginationContent,
  PaginationFirst,
  PaginationItem,
  PaginationLast,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination"

interface PaginationSectionProps {
  currentPage: number
  totalCount: number
  itemsPerPage: number
  onPageChange: (page: number) => void
}

export function PaginationSection({
  currentPage,
  totalCount,
  itemsPerPage,
  onPageChange,
}: PaginationSectionProps) {
  const totalPages = Math.ceil(totalCount / itemsPerPage)
  if (totalPages <= 1) return null

  const startItem = (currentPage - 1) * itemsPerPage + 1
  const endItem = Math.min(currentPage * itemsPerPage, totalCount)

  return (
    <div className="mt-4 flex items-center justify-end">
      <div className="flex items-center gap-4">
        <div className="text-sm text-slate-500 whitespace-nowrap">
          {totalCount} 件中 {startItem} - {endItem} 件を表示
        </div>
        <Pagination>
          <PaginationContent>
            <PaginationItem>
              <PaginationFirst
                onClick={(e) => {
                  e.preventDefault()
                  onPageChange(1)
                }}
                disabled={currentPage === 1}
                className="cursor-pointer"
              />
            </PaginationItem>
            <PaginationItem>
              <PaginationPrevious
                onClick={(e) => {
                  e.preventDefault()
                  onPageChange(currentPage - 1)
                }}
                disabled={currentPage === 1}
                className="cursor-pointer"
              />
            </PaginationItem>
            <PaginationItem>
              <PaginationNext
                onClick={(e) => {
                  e.preventDefault()
                  onPageChange(currentPage + 1)
                }}
                disabled={currentPage === totalPages}
                className="cursor-pointer"
              />
            </PaginationItem>
            <PaginationItem>
              <PaginationLast
                onClick={(e) => {
                  e.preventDefault()
                  onPageChange(totalPages)
                }}
                disabled={currentPage === totalPages}
                className="cursor-pointer"
              />
            </PaginationItem>
          </PaginationContent>
        </Pagination>
      </div>
    </div>
  )
}
